export default {
    Home: 'Home',
    Consulta: 'Consulta',
    RFC: 'RFC',
    Transaccion: 'Transaccion',
    Login: 'Login',
    Ticket: 'Ticket',
    Global: 'Global',
    Parametro: 'Parametro',
    TicketCredito: 'TicketCredito',
    Anulacion: 'Anulacion',
    Bitacora: 'Bitacora'
};


// WEBPACK FOOTER //
// ./Public/src/js/routes.js